export const LOOPIC_CONFIG = {
  allowAccessWithoutRegistration: true,
  allowExportWithoutRegistration: false,
  tutorialFinishedLocalStorageKey: 'tutorial-finished',
};
